import { ASSET_DRAG_TYPE, latestVersion, publicImageUrl } from '../../lib/marketing';
import { CheckCircleIcon, CommentIcon, DragHandleIcon, InstagramIcon } from '../icons';

const STATUS_CLASS = {
  'In Review': 'review',
  'Needs Rework': 'rework',
  Approved: 'approved',
};

const DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

// A library tile: image with its status, a title, the channel, and when it
// landed. Everything editable lives in AssetDetailModal — a ~260px card can't
// hold a comment box and a file input without the controls overflowing.
export default function AssetCard({ asset, commentCount = 0, onOpen }) {
  const current = latestVersion(asset);
  if (!current) return null;

  // No dedicated title field exists, so the caption is the title and the
  // channel carries the supporting line. Untitled assets say so rather than
  // leaving a blank row that looks like a rendering bug.
  const title = current.caption?.trim() || 'Untitled asset';
  const draggableToGrid = asset.channel === 'Instagram';

  return (
    <div
      className={'asset-tile' + (draggableToGrid ? ' asset-tile-draggable' : '')}
      draggable={draggableToGrid}
      onDragStart={
        draggableToGrid
          ? (e) => {
              e.dataTransfer.setData(ASSET_DRAG_TYPE, asset.id);
              e.dataTransfer.effectAllowed = 'copyMove';
            }
          : undefined
      }
    >
      <button className="asset-tile-media" onClick={onOpen} aria-label={`Open ${title}`}>
        {/* Images are natively draggable and cover most of the card; opting
            the image out makes the card the single drag source, instead of
            Chrome starting its own image drag carrying a URL. */}
        <img
          src={publicImageUrl(current.image_path)}
          alt={current.caption || 'Campaign asset'}
          draggable={false}
        />
        <span className={`asset-tile-status asset-tile-status-${STATUS_CLASS[asset.status]}`}>
          {asset.status}
        </span>
        <span className="asset-tile-corner" aria-hidden>
          {asset.status === 'Approved' ? <CheckCircleIcon /> : <DragHandleIcon />}
        </span>
      </button>

      <div className="asset-tile-body">
        <button className="asset-tile-title" onClick={onOpen}>
          {title}
        </button>

        <span className="asset-tile-channel">
          {asset.channel === 'Instagram' && <InstagramIcon />}
          {asset.channel ? `${asset.channel} post` : 'No channel'}
        </span>

        <div className="asset-tile-footer">
          <span>{DATE_FORMAT.format(new Date(current.uploaded_at || asset.created_at))}</span>
          <span className="asset-tile-comments">
            <CommentIcon />
            {commentCount}
          </span>
        </div>
      </div>
    </div>
  );
}
